export enum AllProjectsItemActions {
    Edit = 'edit',
    Delete = 'delete',
    Dashboard = 'dashboard',
    ChangeSettings = 'change-settings'
}
